// Bemby Kids theme JS
(function () {
  // Mobile menu
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.header__nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', nav.classList.contains('is-open'));
    });
  }

  // Scroll reveal
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Quantity selectors
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelector('[data-minus]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    q.querySelector('[data-plus]').addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  // Countdown (weekly reset)
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var days = parseInt(el.getAttribute('data-countdown'), 10) || 3;
    var key = 'bemby_cd_end';
    var end = parseInt(localStorage.getItem(key) || '0', 10);
    var now = Date.now();
    if (!end || end < now) {
      end = now + days * 24 * 60 * 60 * 1000;
      localStorage.setItem(key, String(end));
    }
    var dEl = el.querySelector('[data-d]'), hEl = el.querySelector('[data-h]'),
        mEl = el.querySelector('[data-m]'), sEl = el.querySelector('[data-s]');
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff / 3600000) % 24;
      var m = Math.floor(diff / 60000) % 60;
      var s = Math.floor(diff / 1000) % 60;
      if (dEl) dEl.textContent = d;
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  // Welcome popup
  var overlay = document.getElementById('bemby-popup');
  if (overlay) {
    var delay = parseInt(overlay.getAttribute('data-delay'), 10) || 6;
    if (!localStorage.getItem('bemby_popup_seen')) {
      setTimeout(function () { overlay.classList.add('is-open'); }, delay * 1000);
    }
    function closePopup() {
      overlay.classList.remove('is-open');
      localStorage.setItem('bemby_popup_seen', '1');
    }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    var closeBtn = overlay.querySelector('.popup__close');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    var form = overlay.querySelector('form');
    if (form) form.addEventListener('submit', function () { localStorage.setItem('bemby_popup_seen', '1'); });
  }

  // Sticky mobile buy bar (shows after hero scroll)
  var sticky = document.querySelector('.sticky-buy');
  if (sticky) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 500) sticky.classList.add('is-visible');
      else sticky.classList.remove('is-visible');
    }, { passive: true });
  }

  // Product gallery thumbs
  var mainImg = document.querySelector('[data-main-image]');
  document.querySelectorAll('.product-thumbs img').forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg) { mainImg.src = t.getAttribute('data-full'); mainImg.removeAttribute('srcset'); }
      document.querySelectorAll('.product-thumbs img').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });
})();
